import React from 'react'
import styled from 'styled-components'
import { mediaqueries } from '~/utils/mediaqueries'
import Cart from '~/icons/cart.svg'
import { DoublePica, GreatPrimer, Brevier } from '~/components/Typography'

const Button = styled.button`
  appearance: none;
  border: none;
  outline: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  width: 100%;
  border-radius: 6px;
  z-index: 1000;

  ${({ theme: { color, toRem } }) => `
    background: #19AE5C;
    color: ${color('light')};
    height: ${toRem(70)};
    padding: 0 ${toRem(20)};
    width: calc(100% - 20px);
    left: 10px;
    position: fixed;
    bottom: 20px;
  `}

  @media ${mediaqueries.md} {
      margin: 0;
      ${({ theme: { toRem } }) => `
        padding: 0 ${toRem(20)} 0 ${toRem(30)};
        height: ${toRem(70)};
        right: 10px;
        left: auto;
        bottom: 10px;
        width: calc(30% - 20px);
        position: fixed;
      `};
  }

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.4;
  }
`

const CTA = styled(GreatPrimer)`
  text-transform: uppercase;
  font-weight: 500 !important;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  svg {
    margin-right: 10px;
    
    path {
      stroke: white !important;
    }
  }
`

export const Backdrop = styled.div`
  //background: white;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  height: 90px;

  @media ${mediaqueries.md} {
    display: none;
  }
`

export default ({ disabled, onClick, price }) => {
  return (
    <>
      <Backdrop />
      <Button type="submit" disabled={disabled} onClick={onClick}>
        <CTA>
          <Cart></Cart> LÆG I INDKØBSKURVEN
        </CTA>
        <Brevier>{price}</Brevier>
      </Button>
    </>
  )
}
